import { useState, useEffect } from 'react';

const API_URL = 'https://bot.devit.es/api';
const headers = () => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${localStorage.getItem('devit_token')}`
});

const ESTADO_BADGE = {
  abierto:    'badge-amber',
  en_proceso: 'badge-cyan',
  resuelto:   'badge-green',
  cerrado:    'badge-red',
};

export default function AdminTickets() {
  const [tickets, setTickets]     = useState([]);
  const [seleccionado, setSeleccionado] = useState(null);
  const [respuesta, setRespuesta] = useState('');
  const [estado, setEstado]       = useState('en_proceso');
  const [saving, setSaving]       = useState(false);
  const [msg, setMsg]             = useState('');

  const cargar = () => {
    fetch(`${API_URL}/tickets/admin/todos`, { headers: headers() })
      .then(r => r.json())
      .then(data => setTickets(Array.isArray(data) ? data : []));
  };

  useEffect(() => { cargar(); }, []);

  const responder = async () => {
    if (!respuesta.trim()) return;
    setSaving(true);
    const res = await fetch(`${API_URL}/tickets/admin/${seleccionado.id}`, {
      method: 'PUT', headers: headers(),
      body: JSON.stringify({ respuesta, estado })
    }).then(r => r.json());
    if (res.status === 'ok') {
      setMsg('✓ Respuesta enviada al cliente por email');
      cargar();
      setTimeout(() => setMsg(''), 3000);
    }
    setSaving(false);
  };

  const formatFecha = (str) => {
    const d = new Date(str);
    return d.toLocaleDateString('es-ES', { day:'2-digit', month:'short' }) +
      ' ' + d.toLocaleTimeString('es-ES', { hour:'2-digit', minute:'2-digit' });
  };

  const abiertos = tickets.filter(t => t.estado === 'abierto').length;

  return (
    <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'16px', height:'calc(100vh - 60px)', overflow:'hidden'}}>
      
      {/* Lista */}
      <div style={{overflowY:'auto', padding:'16px'}}>
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'16px'}}>
          <div style={{fontSize:'14px', fontWeight:700, color:'var(--text)'}}>
            Tickets
            {abiertos > 0 && <span className="badge badge-amber" style={{marginLeft:'8px'}}>{abiertos} abiertos</span>}
          </div>
          <button className="btn btn-ghost" style={{fontSize:'11px',padding:'4px 10px'}} onClick={cargar}>↺</button>
        </div>

        {tickets.length === 0 && (
          <div style={{textAlign:'center',padding:'32px',color:'var(--text3)',fontSize:'13px'}}>
            No hay tickets
          </div>
        )}

        {tickets.map(t => (
          <div key={t.id}
            onClick={() => { setSeleccionado(t); setRespuesta(t.respuesta || ''); setEstado(t.estado); }}
            style={{
              padding:'12px 14px', borderRadius:'8px', marginBottom:'8px', cursor:'pointer',
              background: seleccionado?.id === t.id ? 'var(--bg3)' : 'var(--bg2)',
              border: `1px solid ${seleccionado?.id === t.id ? 'rgba(0,229,160,0.3)' : 'var(--border)'}`,
              borderLeft: `3px solid ${t.estado === 'abierto' ? 'var(--amber)' : t.estado === 'en_proceso' ? 'var(--cyan)' : 'var(--green)'}`,
            }}
          >
            <div style={{display:'flex', justifyContent:'space-between', marginBottom:'4px'}}>
              <span style={{fontSize:'13px', fontWeight:600, color:'var(--text)'}}>{t.asunto}</span>
              <span className={`badge ${ESTADO_BADGE[t.estado] || 'badge-amber'}`} style={{fontSize:'9px'}}>{t.estado}</span>
            </div>
            <div style={{fontSize:'11px', color:'var(--text3)', fontFamily:'var(--font-mono)'}}>
              {formatFecha(t.creado_en)} · {t.categoria}
            </div>
          </div>
        ))}
      </div>

      {/* Detalle */}
      <div style={{overflowY:'auto', padding:'16px', borderLeft:'1px solid var(--border)'}}>
        {!seleccionado && (
          <div style={{display:'flex', alignItems:'center', justifyContent:'center', height:'100%', color:'var(--text3)', fontSize:'13px'}}>
            Selecciona un ticket
          </div>
        )}

        {seleccionado && (
          <div>
            <div style={{marginBottom:'16px'}}>
              <div style={{fontSize:'16px', fontWeight:700, color:'var(--text)', marginBottom:'8px'}}>
                {seleccionado.asunto}
              </div>
              <div style={{display:'flex', gap:'6px', marginBottom:'12px'}}>
                <span className={`badge ${ESTADO_BADGE[seleccionado.estado]}`}>{seleccionado.estado}</span>
                <span className="badge badge-cyan">{seleccionado.categoria}</span>
              </div>
            </div>

            <div className="card" style={{marginBottom:'16px'}}>
              <div className="card-title">Consulta del cliente</div>
              <div style={{fontSize:'13px', color:'var(--text2)', lineHeight:'1.7', whiteSpace:'pre-wrap',
                background:'var(--bg3)', padding:'12px', borderRadius:'6px', marginTop:'8px'}}>
                {seleccionado.descripcion}
              </div>
            </div>

            <div className="card">
              <div className="card-title">Responder</div>
              <div className="form-group" style={{marginTop:'12px'}}>
                <label className="form-label">Estado</label>
                <select className="form-input" value={estado} onChange={e => setEstado(e.target.value)}>
                  <option value="en_proceso">En proceso</option>
                  <option value="resuelto">Resuelto</option>
                  <option value="cerrado">Cerrado</option>
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Respuesta</label>
                <textarea className="form-input" rows="6" style={{resize:'vertical', lineHeight:'1.6'}}
                  placeholder="Escribe tu respuesta al cliente..."
                  value={respuesta}
                  onChange={e => setRespuesta(e.target.value)}/>
              </div>
              {msg && <div className="alert alert-success" style={{marginBottom:'12px'}}>{msg}</div>}
              <button className="btn btn-primary" onClick={responder} disabled={saving}>
                {saving ? 'Enviando...' : '→ Enviar respuesta por email'}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}